// removed by extract-text-webpack-plugin
module.exports = {"wrapper-upload-image__icon":"magazines_3SOHl","wrapper-upload-image__button":"magazines_aAwx8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadImage/styles.scss
// module id = 1043
// module chunks = 1